import { sendToMixpanel, getUserProps } from '../mixpanel';
import type { SearchResultsBaseProperties } from './search-results-base-properties';

export interface TrackOpenFiltersProps {
  baseProperties?: SearchResultsBaseProperties;
}

export default ({ baseProperties = {} }: TrackOpenFiltersProps = {}): void =>
  sendToMixpanel('Open Filters', {
    ...baseProperties,
    ...getUserProps(),
  });
